
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class VoucherPostingDialog extends Serenity.PropertyDialog<any, any>
    {

        public form = new VoucherPostingForm(this.idPrefix);
        public entityId: number;
        public vouchernos: Sales.SalesMasterRow[];
        public partyids: number[];
        public transids: number[];
        public vouchertypeid: number;
        public inst;
        public checksuccess: boolean;
        constructor() {
            super();

            q.hideEditorToolbar(this.form.Vouchers);
            q.hideEditorLabel(this.form.Vouchers);
            q.setGridEditorHeight(this.form.Vouchers, 350);
            this.form = new VoucherPostingForm(this.idPrefix);
            this.form.PartyId.changeSelect2(e => {
                var partyid = parseInt(this.form.PartyId.value);
                if (partyid != null && partyid > 0) {
                    let partydetails: OMS.AccountLedgerRow;
                    OMS.AccountLedgerService.Retrieve({ EntityId: partyid }, response => {
                        partydetails = response.Entity;
                    }, { async: false });

                    if (this.vouchertypeid == 32) {
                        Sales.ApprovalOutPostingService.List({ PartyId: partyid, TransIds: this.transids }
                            , response => {
                                var _entities = response.Entities;
                                if (_entities != null && _entities.length > 0)
                                    this.form.Vouchers.setData(response.Entities);

                            }, { async: false });
                    } else if (this.vouchertypeid == 19) {
                        Sales.SalesPostingService.List({ PartyId: partyid, TransIds: this.transids }
                            , response => {
                                var _entities = response.Entities;
                                if (_entities != null && _entities.length > 0)
                                    this.form.Vouchers.setData(response.Entities);

                            }, { async: false });

                    } else if (this.vouchertypeid == 33) {
                        Purchase.ApprovalInReturnPostingService.List({ PartyId: partyid, TransIds: this.transids }
                            , response => {
                                var _entities = response.Entities;
                                if (_entities != null && _entities.length > 0)
                                    this.form.Vouchers.setData(response.Entities);

                            }, { async: false });

                    } else if (this.vouchertypeid == 14) {
                        Purchase.PurchaseReturnPostingService.List({ PartyId: partyid, TransIds: this.transids }
                            , response => {
                                var _entities = response.Entities;
                                if (_entities != null && _entities.length > 0)
                                    this.form.Vouchers.setData(response.Entities);

                            }, { async: false });

                    } else {
                        q.alert("", "No Vouchers available to Import", true, 2999);
                        return;
                    }
                }

                //this.form.Vouchers.values = [];
            })
        }


        protected getDialogTitle(): string {
            return "Filters";
        }


        getDialogOptions() {
            var x = super.getDialogOptions();
            x.height = 500;
            x.width = 1000;
            return x;
        }
        onDialogOpen() {
            super.onDialogOpen();
            if (this.vouchertypeid == 32 || this.vouchertypeid == 19) {
                 this.form.PartyId.cascadeField = "PartyType";
                this.form.PartyId.cascadeValue = "Vendor";
            } else if (this.vouchertypeid == 14 || this.vouchertypeid == 33) {
                this.form.PartyId.cascadeField = "PartyType";
                this.form.PartyId.cascadeValue = "Customer";
            } 
        }
        protected getDialogButtons() {
            return [
                {
                    text: 'Ok',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;
                        this.checksuccess = true; 
                        var self = this;
                        this.vouchernos = this.form.Vouchers.rowSelection.getSelectedKeys().map(function (x) { return self.form.Vouchers.view.getItemById(x); });
                        this.checksuccess = true;
                        this.dialogClose();
                        return true; 
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}